export default function LoginRequired(store) {
  return store.getters['user/isLogged'];
}



// WEBPACK FOOTER //
// ./src/loginRequired.js